"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedtagsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedtagsm` : '') + (description ? ` desc-brandedtagsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedtagsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedtagsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m20.82 17.36 3.05-4.33a.6.6 0 0 0-.16-.83L11.92 3.94a.6.6 0 0 0-.45-.1L3.95 5.15a.58.58 0 0 0-.3.16l-.06.06a.4.4 0 0 0-.04.09.57.57 0 0 0-.04.33l1.34 7.52c.03.15.12.3.24.38l11.8 8.26a.6.6 0 0 0 .82-.14l3.04-4.34.07-.1ZM6.37 8.31c-.05-.31.02-.61.19-.86.17-.24.43-.41.74-.47a1.2 1.2 0 0 1 1.38.97c.06.3 0 .61-.18.87-.18.24-.44.41-.75.46a1.2 1.2 0 0 1-1.38-.96Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m23.71 12.2-.93-.64a32.36 32.36 0 0 1-18.02 1.26l.09.49c.03.15.1.28.23.37l11.82 8.28a.6.6 0 0 0 .81-.15l3.04-4.34.07-.1 3.04-4.34a.6.6 0 0 0-.15-.83Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedtagsm;